import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  async getMainData(params) {
    try {
      const response = await axios.get('uni/examination_schedulers_batch', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { total, records } = data.data
        return { total, records }
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async createData(body) {
    try {
      const response = await axios.post('uni/examination_schedulers_batch', body)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },

  async updateData(params) {
    try {
      const response = await axios.put(`uni/examination_schedulers_batch/${params.id}`, params)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },

  async deleteData(id) {
    try {
      const response = await axios.delete(`uni/examination_schedulers_batch/${id}`)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },

  async getCreditClasses(params) {
    try {
      const response = await axios.get('uni/examination_schedulers_batch/getCreditClass/', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const records = data.data
        if (records.length > 0) {
          return records.map(item => ({
            value: item.id,
            label: `${item.subjectName}-${item.code}`,
          }))
        }
        return []
      }
    } catch (e) {
      handleCatch(e)
    }
    return []
  },

  async getCreditClassesByScheduler(params) {
    try {
      const response = await axios.get('uni/examination_schedulers_batch/getCreditClassBySchedulerId', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
}
